<div class="row no-gutters">

  <ng-container *ngIf="!IS_HIDE_USAGE_DETAILS && accountOnboardingData && accountOnboardingData.length > 0">
    
    <div class="col-12 mt-4 font14-700">Account Onboarding</div>
    <div class="col-12 mt-3 table-responsive">
      <table class="table table-striped tbl-scrollable">
        <thead class="thead-light cursor-pointer">
          <tr>
            <th width="20%" scope="col" (click)="onSortByDateClick(accountOnboardingData, serviceNames[3], columns[0])">
              Date Time&nbsp;&nbsp;<span *ngIf="tableSelectedSortOptions[3][1] == columns[0]"><i
                  *ngIf="tableSelectedSortOptions[3][2] == sortType[1]" class="fa fa-arrow-up" aria-hidden="true"></i><i
                  *ngIf="tableSelectedSortOptions[3][2] == sortType[0]" class="fa fa-arrow-down"
                  aria-hidden="true"></i></span></th>
            <th width="30%" scope="col"
              (click)="onSortByStringClick(accountOnboardingData, serviceNames[3], columns[1])">
              Correlation Id&nbsp;&nbsp;<span *ngIf="tableSelectedSortOptions[3][1] == columns[1]"><i
                  *ngIf="tableSelectedSortOptions[3][2] == sortType[1]" class="fa fa-arrow-up" aria-hidden="true"></i><i
                  *ngIf="tableSelectedSortOptions[3][2] == sortType[0]" class="fa fa-arrow-down"
                  aria-hidden="true"></i></span></th>
            <th width="40%" scope="col"
              (click)="onSortByStringClick(accountOnboardingData, serviceNames[3], columns[3])">
              Service Name&nbsp;&nbsp;<span *ngIf="tableSelectedSortOptions[3][1] == columns[3]"><i
                  *ngIf="tableSelectedSortOptions[3][2] == sortType[1]" class="fa fa-arrow-up" aria-hidden="true"></i><i
                  *ngIf="tableSelectedSortOptions[3][2] == sortType[0]" class="fa fa-arrow-down"
                  aria-hidden="true"></i></span></th>
            <th width="10%" scope="col"
              (click)="onSortByStringClick(accountOnboardingData, serviceNames[3], columns[6])">
              Status&nbsp;&nbsp;<span *ngIf="tableSelectedSortOptions[3][1] == columns[6]"><i
                  *ngIf="tableSelectedSortOptions[3][2] == sortType[1]" class="fa fa-arrow-up" aria-hidden="true"></i><i
                  *ngIf="tableSelectedSortOptions[3][2] == sortType[0]" class="fa fa-arrow-down"
                  aria-hidden="true"></i></span></th>
          </tr>
        </thead>
        <tbody class="scroll-height-screenHeight hide-x-scroll">
          <tr *ngFor="let usage of accountOnboardingData; let i = index">
            <td width="20%">{{usage.requestStartTime | date: utilService.countryData.dateFormat + ' ' + utilService.countryData.timeFormat : utilService.countryData.timezone}}</td>
            <td width="30%" class="w-break">{{usage.correlationId}}</td>
            <td width="40%">
              <span *ngIf="displayNameMap.get(usage.serviceName) else showCustomText">
                {{displayNameMap.get(usage.serviceName)}}
              </span>
              <ng-template #showCustomText>
                {{usage.serviceName | customText}}
              </ng-template>
            </td>


            <!-- <td>{{usage.serviceName | customText}}</td> -->
            <td width="10%">{{usage.operationStatus | customText}}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </ng-container>

  <ng-container *ngIf="accountServicePackageProvisioningData && accountServicePackageProvisioningData.length > 0">
    <div class="col-12 mt-4 font14-700">Account Service Package Provisioning</div>
    <div class="col-12 mt-3 table-responsive no-gutter">
      <table class="table table-striped tbl-scrollable">
        <thead class="thead-light cursor-pointer">
          <tr>
            <th width="20%" scope="col"
              (click)="onSortByDateClick(accountServicePackageProvisioningData, serviceNames[0], columns[0])">Date
              Time&nbsp;&nbsp;<span *ngIf="tableSelectedSortOptions[0][1] == columns[0]"><i
                  *ngIf="tableSelectedSortOptions[0][2] == sortType[1]" class="fa fa-arrow-up" aria-hidden="true"></i><i
                  *ngIf="tableSelectedSortOptions[0][2] == sortType[0]" class="fa fa-arrow-down"
                  aria-hidden="true"></i></span></th>
            <th width="30%" scope="col"
              (click)="onSortByStringClick(accountServicePackageProvisioningData, serviceNames[0], columns[1])">
              Correlation Id&nbsp;&nbsp;<span *ngIf="tableSelectedSortOptions[0][1] == columns[1]"><i
                  *ngIf="tableSelectedSortOptions[0][2] == sortType[1]" class="fa fa-arrow-up" aria-hidden="true"></i><i
                  *ngIf="tableSelectedSortOptions[0][2] == sortType[0]" class="fa fa-arrow-down"
                  aria-hidden="true"></i></span></th>
            <th width="20%" scope="col">Package Name</th>
            <th width="20%" scope="col">Command</th>
            <th width="10%" scope="col"
              (click)="onSortByStringClick(accountServicePackageProvisioningData, serviceNames[0], columns[2])">
              Status&nbsp;&nbsp;<span *ngIf="tableSelectedSortOptions[0][1] == columns[2]"><i
                  *ngIf="tableSelectedSortOptions[0][2] == sortType[1]" class="fa fa-arrow-up" aria-hidden="true"></i><i
                  *ngIf="tableSelectedSortOptions[0][2] == sortType[0]" class="fa fa-arrow-down"
                  aria-hidden="true"></i></span></th>
          </tr>
        </thead>
        <tbody class="max-height-57 hide-x-scroll" id="accordionAccountServicePackage">
          <ng-container *ngFor="let usage of accountServicePackageProvisioningData; let i = index">
            <tr class="pointer" data-toggle="collapse" [attr.data-target]="'#udr-account-service-package-' + i"
              aria-expanded="false" aria-controls="'udr-account-service-package-' + i">
              <td width="20%">{{usage.requestStartTime | date: utilService.countryData.dateFormat + ' ' + utilService.countryData.timeFormat : utilService.countryData.timezone}}</td>
              <td width="30%" class="w-break">{{usage.correlationId}}</td>
              <!-- <td class="w-break">{{usage.origin}}</td> -->
              <!-- <td>{{usage.serviceName | customText}}</td> -->
              <td width="20%">
                <ng-container *ngFor="let action of usage.interimActions;">
                  <div *ngIf="action.packageName">
                    {{action.packageName}}
                  </div>
                </ng-container>
              </td>
              <td width="20%">
                <ng-container *ngFor="let action of usage.interimActions;">
                  <div *ngIf="action.command">
                    {{getPackageMessage(action.command) | customText}}
                  </div>
                </ng-container>
              </td>
              <td width="10%">{{usage.operationStatus | customText}}</td>
            </tr>
            <tr [attr.id]="'udr-account-service-package-' + i" class="collapse"
              data-parent="#accordionAccountServicePackage">
              <td class="p-0" colspan="5">
                <div class="card">
                  <div class="row m-2 bg-light no-gutter pb-1">
                    <div class="col-md-3 col-sm-6 col-12 mt-1 pr-0">
                      <div class="font13-400"><span class="font14-700">Origin: </span>{{usage.origin}}</div>
                    </div>
                  </div>
                  <div *ngIf="usage.interimActions && usage.interimActions.length > 0" class="row">
                    <div class="col-sm-12 font13-600 m-2">Packages</div>
                    <div class="col-sm-12 mt-2 col-md table-responsive">
                      <table class="table">
                        <thead class="thead-light cursor-pointer">
                          <tr>
                            <th scope="col">Start Date Time</th>
                            <th scope="col">End Date Time</th>
                            <th scope="col">Request Type</th>
                            <th scope="col">Package Id</th>
                            <th scope="col">Package Name</th>
                            <!-- <th scope="col">Command</th> -->
                            <th scope="col">Status</th>
                          </tr>
                        </thead>
                        <tbody>
                          <ng-container *ngFor="let action of usage.interimActions;">
                            <tr *ngIf="action.operation != 'FINAL'">
                              <td>{{action.requestTime | date: utilService.countryData.dateFormat + ' ' + utilService.countryData.timeFormat : utilService.countryData.timezone}}</td>
                              <td>{{action.lastModifiedDate | date: utilService.countryData.dateFormat + ' ' + utilService.countryData.timeFormat : utilService.countryData.timezone}}</td>
                              <td>{{action.operation | customText}}</td>
                              <td><span *ngIf="action.packageId">{{action.packageId}}</span></td>
                              <td><span *ngIf="action.packageName">{{action.packageName}}</span></td>
                              <!-- <td>{{getPackageMessage(action.command) | customText}}</td> -->
                              <td>{{action.operationStatus | customText}}</td>
                            </tr>
                            <tr *ngIf="action.operation == 'FINAL'">
                              <td>{{action.requestTime | date: utilService.countryData.dateFormat + ' ' + utilService.countryData.timeFormat : utilService.countryData.timezone}}</td>
                              <td>{{action.lastModifiedDate | date: utilService.countryData.dateFormat + ' ' + utilService.countryData.timeFormat : utilService.countryData.timezone}}</td>
                              <td>{{action.operation | customText}}</td>
                              <td>-</td>
                              <td>-</td>
                              <!-- <td>-</td> -->
                              <td>{{action.operationStatus | customText}}</td>
                            </tr>
                          </ng-container>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          </ng-container>
        </tbody>
      </table>
    </div>
  </ng-container>

  <ng-container *ngIf="vehicleOnboardingData && vehicleOnboardingData.length > 0">
    <div class="col-12 mt-4 font14-700">Vehicle Onboarding</div>
    <div class="col-12 mt-3 table-responsive no-gutter">
      <table class="table table-striped tbl-scrollable">
        <thead class="thead-light cursor-pointer">
          <tr>
            <th width="20%" scope="col" (click)="onSortByDateClick(vehicleOnboardingData, serviceNames[1], columns[0])">
              Date Time&nbsp;&nbsp;<span *ngIf="tableSelectedSortOptions[1][1] == columns[0]"><i
                  *ngIf="tableSelectedSortOptions[1][2] == sortType[1]" class="fa fa-arrow-up" aria-hidden="true"></i><i
                  *ngIf="tableSelectedSortOptions[1][2] == sortType[0]" class="fa fa-arrow-down"
                  aria-hidden="true"></i></span></th>
            <th width="30%" scope="col"
              (click)="onSortByStringClick(vehicleOnboardingData, serviceNames[1], columns[1])">Correlation
              Id&nbsp;&nbsp;<span *ngIf="tableSelectedSortOptions[1][1] == columns[1]"><i
                  *ngIf="tableSelectedSortOptions[1][2] == sortType[1]" class="fa fa-arrow-up" aria-hidden="true"></i><i
                  *ngIf="tableSelectedSortOptions[1][2] == sortType[0]" class="fa fa-arrow-down"
                  aria-hidden="true"></i></span></th>
            <th width="40%" scope="col"
              (click)="onSortByStringClick(vehicleOnboardingData, serviceNames[1], columns[2])">VIN&nbsp;&nbsp;<span
                *ngIf="tableSelectedSortOptions[1][1] == columns[2]"><i
                  *ngIf="tableSelectedSortOptions[1][2] == sortType[1]" class="fa fa-arrow-up" aria-hidden="true"></i><i
                  *ngIf="tableSelectedSortOptions[1][2] == sortType[0]" class="fa fa-arrow-down"
                  aria-hidden="true"></i></span></th>
            <th width="10%" scope="col"
              (click)="onSortByStringClick(vehicleOnboardingData, serviceNames[1], columns[6])">Status&nbsp;&nbsp;<span
                *ngIf="tableSelectedSortOptions[1][1] == columns[6]"><i
                  *ngIf="tableSelectedSortOptions[1][2] == sortType[1]" class="fa fa-arrow-up" aria-hidden="true"></i><i
                  *ngIf="tableSelectedSortOptions[1][2] == sortType[0]" class="fa fa-arrow-down"
                  aria-hidden="true"></i></span></th>
          </tr>
        </thead>
        <tbody class="max-height-57 hide-x-scroll" id="accordionVehicleOnboarding">
          <ng-container *ngFor="let usage of vehicleOnboardingData; let i = index">
            <tr class="pointer" data-toggle="collapse" [attr.data-target]="'#udr-vehicle-onboarding-' + i"
              aria-expanded="false" aria-controls="'udr-vehicle-onboarding-' + i">
              <td width="20%">{{usage.requestStartTime | date: utilService.countryData.dateFormat + ' ' + utilService.countryData.timeFormat : utilService.countryData.timezone}}</td>
              <td width="30%" class="w-break">{{usage.correlationId}}</td>
              <td width="40%" class="w-break"><span *ngIf="usage.vin">{{usage.vin}}</span></td>
              <!-- <td>{{usage.serviceName | customText}}</td> -->
              <td width="10%">{{usage.operationStatus | customText}}</td>
            </tr>
            <tr [attr.id]="'udr-vehicle-onboarding-' + i" class="collapse" data-parent="#accordionVehicleOnboarding">
              <td class="p-0" colspan="5">
                <div class="card">
                  <div class="row m-2 bg-light no-gutter pb-1">
                    <div class="col-md-4 col-sm-6 col-12 mt-1 pr-0">
                      <div class="font14-700">{{usage.vin}}</div><br *ngIf="usage.vin">
                      <div class="font13-400"><span class="font14-700">Origin: </span>{{usage.origin}}</div>
                    </div>
                    <!-- <div class="col-md-4 col-sm-6 col-12 mt-1">
                      <div class="font14-700">Facility Location</div>
                      <div class="font13-400 mt-1"
                        *ngIf="usage.vehicleLocationDetail && usage.vehicleLocationDetail.facilityLocation; else noLocation">
                        <span
                          *ngIf="usage.vehicleLocationDetail.facilityLocation.street">{{usage.vehicleLocationDetail.facilityLocation.street}}</span><br>
                        <span
                          *ngIf="usage.vehicleLocationDetail.facilityLocation.city">{{usage.vehicleLocationDetail.facilityLocation.city}}</span>
                        <span *ngIf="usage.vehicleLocationDetail.facilityLocation.state">,
                          {{usage.vehicleLocationDetail.facilityLocation.state}}</span>
                        <span *ngIf="usage.vehicleLocationDetail.facilityLocation.zipCode">,
                          {{usage.vehicleLocationDetail.facilityLocation.zipCode}}</span>
                      </div>
                    </div>
                    <div class="col-md-4 col-sm-6 col-12 mt-1">
                      <div class="font14-700">Home Location</div>
                      <div class="font13-400 mt-1"
                        *ngIf="usage.homeLocation && usage.homeLocation.address; else noLocation">
                        <span *ngIf="usage.homeLocation.address.street">{{usage.homeLocation.address.street}}</span><br>
                        <span *ngIf="usage.homeLocation.address.city">{{usage.homeLocation.address.city}}</span>
                        <span *ngIf="usage.homeLocation.address.state">, {{usage.homeLocation.address.state}}</span>
                        <span *ngIf="usage.homeLocation.address.zipCode">, {{usage.homeLocation.address.zipCode}}</span>
                      </div>
                    </div> -->
                  </div>
                  <div class="row mt-3" *ngIf="usage.interimActions && usage.interimActions.length > 0">
                    <div class="col-sm-12 font13-600 m-2">Interim Actions</div>
                    <div class="col-sm-12 mt-2 col-md table-responsive">
                      <table class="table">
                        <thead class="thead-light cursor-pointer">
                          <tr>
                            <th scope="col">Start Date Time</th>
                            <th scope="col">End Date Time</th>
                            <th scope="col">Request Type</th>
                            <th scope="col">Command</th>
                            <th scope="col">Status</th>
                          </tr>
                        </thead>
                        <tbody>
                          <ng-container *ngFor="let action of usage.interimActions;">
                            <tr *ngIf="action.packageId == null && action.packageName == null">
                              <td>{{action.requestTime | date: utilService.countryData.dateFormat + ' ' + utilService.countryData.timeFormat : utilService.countryData.timezone}}</td>
                              <td>{{action.lastModifiedDate | date: utilService.countryData.dateFormat + ' ' + utilService.countryData.timeFormat : utilService.countryData.timezone}}</td>
                              <td>{{action.operation | customText}}</td>
                              <!-- <td><span *ngIf="action.command">{{action.command | customText}}</span></td> -->
                              <td><span>{{usage.serviceName | customText}}</span></td>
                              <td>{{action.operationStatus | customText}}</td>
                            </tr>
                          </ng-container>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div class="row mt-3 no-gutter" *ngIf="usage.interimActions && usage.interimActions.length > 0">
                    <div class="col-sm-12 font13-600 m-2">Packages</div>
                    <div class="col-sm-12 mt-2 col-md table-responsive">
                      <table class="table">
                        <thead class="thead-light cursor-pointer">
                          <tr>
                            <th scope="col">Start Date Time</th>
                            <th scope="col">End Date Time</th>
                            <th scope="col">Request Type</th>
                            <th scope="col">Package Id</th>
                            <th scope="col">Package Name</th>
                            <th scope="col">Command</th>
                            <th scope="col">Status</th>
                          </tr>
                        </thead>
                        <tbody>
                          <ng-container *ngFor="let action of usage.interimActions;">
                            <tr *ngIf="action.packageId && action.packageName">
                              <td>{{action.requestTime | date: utilService.countryData.dateFormat + ' ' + utilService.countryData.timeFormat : utilService.countryData.timezone}}</td>
                              <td>{{action.lastModifiedDate | date: utilService.countryData.dateFormat + ' ' + utilService.countryData.timeFormat : utilService.countryData.timezone}}</td>
                              <td>{{action.operation | customText}}</td>
                              <td>{{action.packageId}}</td>
                              <td>{{action.packageName}}</td>
                              <td><span *ngIf="action.command">{{getPackageMessage(action.command) | customText}}</span>
                              </td>
                              <td>{{action.operationStatus | customText}}</td>
                            </tr>
                          </ng-container>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          </ng-container>
        </tbody>
      </table>
    </div>
  </ng-container>

  <ng-container *ngIf="!IS_HIDE_USAGE_DETAILS && vehicleServicePackageProvisioningData && vehicleServicePackageProvisioningData.length > 0">
    <div class="col-12 mt-4 font14-700">Vehicle Service Package Provisioning</div>
    <div class="col-12 mt-3 table-responsive no-gutter">
      <table class="table table-striped tbl-scrollable">
        <thead class="thead-light cursor-pointer">
          <tr>
            <th width="15%" scope="col"
              (click)="onSortByDateClick(vehicleServicePackageProvisioningData, serviceNames[2], columns[0])">Date
              Time&nbsp;&nbsp;<span *ngIf="tableSelectedSortOptions[2][1] == columns[0]"><i
                  *ngIf="tableSelectedSortOptions[2][2] == sortType[1]" class="fa fa-arrow-up" aria-hidden="true"></i><i
                  *ngIf="tableSelectedSortOptions[2][2] == sortType[0]" class="fa fa-arrow-down"
                  aria-hidden="true"></i></span></th>
            <th width="25%" scope="col"
              (click)="onSortByStringClick(vehicleServicePackageProvisioningData, serviceNames[2], columns[1])">
              Correlation Id&nbsp;&nbsp;<span *ngIf="tableSelectedSortOptions[2][1] == columns[1]"><i
                  *ngIf="tableSelectedSortOptions[2][2] == sortType[1]" class="fa fa-arrow-up" aria-hidden="true"></i><i
                  *ngIf="tableSelectedSortOptions[2][2] == sortType[0]" class="fa fa-arrow-down"
                  aria-hidden="true"></i></span></th>
            <th width="15%" scope="col"
              (click)="onSortByStringClick(vehicleServicePackageProvisioningData, serviceNames[2], columns[2])">
              VIN&nbsp;&nbsp;<span *ngIf="tableSelectedSortOptions[2][1] == columns[2]"><i
                  *ngIf="tableSelectedSortOptions[2][2] == sortType[1]" class="fa fa-arrow-up" aria-hidden="true"></i><i
                  *ngIf="tableSelectedSortOptions[2][2] == sortType[0]" class="fa fa-arrow-down"
                  aria-hidden="true"></i></span></th>
            <th width="20%" scope="col">Package Name</th>
            <th width="15%" scope="col">Command</th>
            <th width="10%" scope="col"
              (click)="onSortByStringClick(vehicleServicePackageProvisioningData, serviceNames[2], columns[6])">
              Status&nbsp;&nbsp;<span *ngIf="tableSelectedSortOptions[2][1] == columns[6]"><i
                  *ngIf="tableSelectedSortOptions[2][2] == sortType[1]" class="fa fa-arrow-up" aria-hidden="true"></i><i
                  *ngIf="tableSelectedSortOptions[2][2] == sortType[0]" class="fa fa-arrow-down"
                  aria-hidden="true"></i></span></th>
          </tr>
        </thead>
        <tbody class="max-height-57 hide-x-scroll" id="accordionVehicleServicePackage">
          <ng-container *ngFor="let usage of vehicleServicePackageProvisioningData; let i = index">
            <tr class="pointer" data-toggle="collapse" [attr.data-target]="'#udr-vehicle-service-package-' + i"
              aria-expanded="false" aria-controls="'udr-vehicle-service-package-' + i">
              <td width="15%">{{usage.requestStartTime | date: utilService.countryData.dateFormat + ' ' + utilService.countryData.timeFormat : utilService.countryData.timezone}}</td>
              <td width="25%" class="w-break">{{usage.correlationId}}</td>
              <td width="15%" class="w-break">{{usage.vin}}</td>
              <!-- <td>{{usage.serviceName | customText}}</td> -->
              <td width="20%">
                <ng-container *ngFor="let action of usage.interimActions;">
                  <div *ngIf="action.packageName">
                    {{action.packageName}}
                  </div>
                </ng-container>
              </td>
              <td width="15%">
                <ng-container *ngFor="let action of usage.interimActions;">
                  <div *ngIf="action.command">
                    {{getPackageMessage(action.command) | customText}}
                  </div>
                </ng-container>
              </td>
              <td width="10%">{{usage.operationStatus | customText}}</td>
            </tr>
            <tr [attr.id]="'udr-vehicle-service-package-' + i" class="collapse"
              data-parent="#accordionVehicleServicePackage">
              <td class="p-0" colspan="6">
                <div class="card">
                  <div *ngIf="usage.interimActions && usage.interimActions.length > 0" class="row">
                    <div class="col-sm-12 font13-600 m-2">Packages</div>
                    <div class="col-sm-12 mt-2 col-md table-responsive">
                      <table class="table">
                        <thead class="thead-light cursor-pointer">
                          <tr>
                            <th width="15%" scope="col">Start Date Time</th>
                            <th width="25%" scope="col">End Date Time</th>
                            <th width="15%" scope="col">Request Type</th>
                            <th width="20%" scope="col">Package Id</th>
                            <th width="15%" scope="col">Package Name</th>
                            <!-- <th scope="col">Command</th> -->
                            <th width="10%" scope="col">Status</th>
                          </tr>
                        </thead>
                        <tbody>
                          <ng-container *ngFor="let action of usage.interimActions;">
                            <tr>
                              <td width="15%">{{action.requestTime | date: utilService.countryData.dateFormat + ' ' + utilService.countryData.timeFormat : utilService.countryData.timezone}}</td>
                              <td width="25%">{{action.lastModifiedDate | date: utilService.countryData.dateFormat + ' ' + utilService.countryData.timeFormat : utilService.countryData.timezone}}</td>
                              <td width="15%">{{action.operation | customText}}</td>
                              <td width="20%"><span *ngIf="action.packageId">{{action.packageId}}</span></td>
                              <td width="15%"><span *ngIf="action.packageName">{{action.packageName}}</span></td>
                              <!-- <td width="15%"><span *ngIf="action.command">{{getPackageMessage(action.command) | customText}}</span></td> -->
                              <td width="10%">{{action.operationStatus | customText}}</td>
                            </tr>
                          </ng-container>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          </ng-container>
        </tbody>
      </table>
    </div>
  </ng-container>

  <ng-container *ngIf="userOnboardingData && userOnboardingData.length > 0">
    <div class="col-12 mt-4 font14-700">User Onboarding</div>
    <div class="col-12 mt-3 table-responsive no-gutter">
      <table class="table table-striped tbl-scrollable">
        <thead class="thead-light cursor-pointer">
          <tr>
            <th width="20%" scope="col" (click)="onSortByDateClick(userOnboardingData, serviceNames[3], columns[0])">
              Date Time&nbsp;&nbsp;<span *ngIf="tableSelectedSortOptions[3][1] == columns[0]"><i
                  *ngIf="tableSelectedSortOptions[3][2] == sortType[1]" class="fa fa-arrow-up" aria-hidden="true"></i><i
                  *ngIf="tableSelectedSortOptions[3][2] == sortType[0]" class="fa fa-arrow-down"
                  aria-hidden="true"></i></span></th>
            <th width="30%" scope="col" (click)="onSortByStringClick(userOnboardingData, serviceNames[3], columns[1])">
              Correlation Id&nbsp;&nbsp;<span *ngIf="tableSelectedSortOptions[3][1] == columns[1]"><i
                  *ngIf="tableSelectedSortOptions[3][2] == sortType[1]" class="fa fa-arrow-up" aria-hidden="true"></i><i
                  *ngIf="tableSelectedSortOptions[3][2] == sortType[0]" class="fa fa-arrow-down"
                  aria-hidden="true"></i></span></th>
            <th width="20%" scope="col">User</th>
            <th width="20%" scope="col">Action</th>
            <!-- <th width="40%" scope="col" (click)="onSortByStringClick(userOnboardingData, serviceNames[3], columns[3])">
              User Id&nbsp;&nbsp;<span *ngIf="tableSelectedSortOptions[3][1] == columns[3]"><i
                  *ngIf="tableSelectedSortOptions[3][2] == sortType[1]" class="fa fa-arrow-up" aria-hidden="true"></i><i
                  *ngIf="tableSelectedSortOptions[3][2] == sortType[0]" class="fa fa-arrow-down"
                  aria-hidden="true"></i></span></th> -->
            <th width="10%" scope="col" (click)="onSortByStringClick(userOnboardingData, serviceNames[3], columns[6])">
              Status&nbsp;&nbsp;<span *ngIf="tableSelectedSortOptions[3][1] == columns[6]"><i
                  *ngIf="tableSelectedSortOptions[3][2] == sortType[1]" class="fa fa-arrow-up" aria-hidden="true"></i><i
                  *ngIf="tableSelectedSortOptions[3][2] == sortType[0]" class="fa fa-arrow-down"
                  aria-hidden="true"></i></span></th>
          </tr>
        </thead>
        <tbody class="max-height-57 hide-x-scroll">
          <tr *ngFor="let usage of userOnboardingData; let i = index">
            <td width="20%">{{usage.requestStartTime | date: utilService.countryData.dateFormat + ' ' + utilService.countryData.timeFormat : utilService.countryData.timezone}}</td>
            <td width="30%" class="w-break">{{usage.correlationId}}</td>
            <!-- <td width="20%" class="w-break">
              <span *ngIf="usage.metaData && usage.metaData.email">{{usage.metaData.email}}</span>
            </td> -->
            <td width="20%" class="w-break">
              <span *ngIf="usage.interimActions && usage.interimActions.length > 0 && usage.interimActions[0].metaData; else showUserId">
                {{usage.interimActions[0].metaData.email}}
              </span>
              <ng-template #showUserId>
                {{usage.userId}}
              </ng-template>
            </td>
            <td width="20%" class="w-break">
              <span>{{getUserOnboardingAction(usage)}}</span>
            </td>
            <!-- <td width="40%" class="w-break">{{usage.userId}}</td> -->
            <!-- <td>{{usage.serviceName | customText}}</td> -->
            <td width="10%">{{usage.operationStatus | customText}}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </ng-container>

  <ng-container *ngIf="!IS_HIDE_USAGE_DETAILS && usageUiData && usageUiData.length > 0 && !allEmailNotification(usageUiData)">
    <div class="col-12 mt-4 font14-700">Remote Services</div>
    <div class="col-12 mt-3 table-responsive no-gutter">
      <table class="table table-striped tbl-scrollable">
        <thead class="thead-light cursor-pointer">
          <tr>
            <th width="20%" scope="col" (click)="onSortByDateClick(usageUiData, serviceNames[4], columns[0])">Date
              Time&nbsp;&nbsp;<span *ngIf="tableSelectedSortOptions[4][1] == columns[0]"><i
                  *ngIf="tableSelectedSortOptions[4][2] == sortType[1]" class="fa fa-arrow-up" aria-hidden="true"></i><i
                  *ngIf="tableSelectedSortOptions[4][2] == sortType[0]" class="fa fa-arrow-down"
                  aria-hidden="true"></i></span></th>
            <th width="30%" scope="col" (click)="onSortByStringClick(usageUiData, serviceNames[4], columns[1])">
              Correlation Id&nbsp;&nbsp;<span *ngIf="tableSelectedSortOptions[4][1] == columns[1]"><i
                  *ngIf="tableSelectedSortOptions[4][2] == sortType[1]" class="fa fa-arrow-up" aria-hidden="true"></i><i
                  *ngIf="tableSelectedSortOptions[4][2] == sortType[0]" class="fa fa-arrow-down"
                  aria-hidden="true"></i></span></th>
            <th width="20%" scope="col" (click)="onSortByStringClick(usageUiData, serviceNames[4], columns[2])">
              VIN&nbsp;&nbsp;<span *ngIf="tableSelectedSortOptions[4][1] == columns[2]"><i
                  *ngIf="tableSelectedSortOptions[4][2] == sortType[1]" class="fa fa-arrow-up" aria-hidden="true"></i><i
                  *ngIf="tableSelectedSortOptions[4][2] == sortType[0]" class="fa fa-arrow-down"
                  aria-hidden="true"></i></span></th>
            <th width="20%" scope="col" (click)="onSortByStringClick(usageUiData, serviceNames[4], columns[4])">Service
              Name&nbsp;&nbsp;<span *ngIf="tableSelectedSortOptions[4][1] == columns[4]"><i
                  *ngIf="tableSelectedSortOptions[4][2] == sortType[1]" class="fa fa-arrow-up" aria-hidden="true"></i><i
                  *ngIf="tableSelectedSortOptions[4][2] == sortType[0]" class="fa fa-arrow-down"
                  aria-hidden="true"></i></span></th>
            <th width="10%" scope="col" (click)="onSortByStringClick(usageUiData, serviceNames[4], columns[6])">
              Status&nbsp;&nbsp;<span *ngIf="tableSelectedSortOptions[4][1] == columns[6]"><i
                  *ngIf="tableSelectedSortOptions[4][2] == sortType[1]" class="fa fa-arrow-up" aria-hidden="true"></i><i
                  *ngIf="tableSelectedSortOptions[4][2] == sortType[0]" class="fa fa-arrow-down"
                  aria-hidden="true"></i></span></th>
          </tr>
        </thead>
        <tbody id="accordion"
          class="max-height-57 hide-x-scroll"
          [scrollWindow]="false"
          infiniteScroll
          [infiniteScrollDistance]="infiniteScrollDistance"
          [infiniteScrollThrottle]="infiniteScrollThrottle"
          (scrolled)="onScrollDown()"
        >
          <ng-container *ngFor="let usage of usageUiData; let i = index">
            <ng-container *ngIf="usage.serviceName && usage.serviceName != 'EMAIL_NOTIFICATION'">
              <tr class="pointer" data-toggle="collapse" [attr.data-target]="'#udr-' + i" aria-expanded="false"
                aria-controls="'udr-' + i">
                <td width="20%">{{usage.requestStartTime | date: utilService.countryData.dateFormat + ' ' + utilService.countryData.timeFormat : utilService.countryData.timezone}}</td>
                <!-- <td style="word-break:break-word;">{{usage.correlationId}}</td> -->
                <td width="30%" class="w-break">{{usage.correlationId}}</td>
                <td width="20%" class="w-break"><span *ngIf="usage.vin">{{usage.vin}}</span></td>
                <!-- <td
                *ngIf="usage.facilityLocation != null && usage.facilityLocation.address != null && usage.facilityLocation.address.city != null">
                {{usage.facilityLocation.address.city}}</td>
              <td
                *ngIf="usage.facilityLocation == null || usage.facilityLocation.address == null || usage.facilityLocation.address.city == null">
              </td> -->
                <td width="20%">{{usage.serviceName | customText}}</td>
                <!-- <td></td> -->
                <td width="10%">{{usage.operationStatus | customText}}</td>
              </tr>
              <tr [attr.id]="'udr-' + i" class="collapse" data-parent="#accordion">
                <td class="p-0" colspan="5">
                  <div class="card">
                    <div class="row m-2 bg-light no-gutter pb-1">
                      <div class="col-md-3 col-sm-6 col-12 mt-1 pr-0">
                        <div class="font14-700">{{usage.vin}}</div><br *ngIf="usage.vin">
                        <div class="font13-400"><span class="font14-700">Origin: </span>{{usage.origin == 'Unknown' ? 'Nissan Test App' : usage.origin}}</div>
                      </div>
                      <!-- <div class="col-md-3 col-sm-6 col-12 mt-1">
                        <div class="font14-700">Facility Location</div>
                        <div class="font13-400 mt-1"
                          *ngIf="usage.vehicleLocationDetail && usage.vehicleLocationDetail.facilityLocation; else noLocation">
                          <span
                            *ngIf="usage.vehicleLocationDetail.facilityLocation.street">{{usage.vehicleLocationDetail.facilityLocation.street}}</span><br>
                          <span
                            *ngIf="usage.vehicleLocationDetail.facilityLocation.city">{{usage.vehicleLocationDetail.facilityLocation.city}}</span>
                          <span *ngIf="usage.vehicleLocationDetail.facilityLocation.state">,
                            {{usage.vehicleLocationDetail.facilityLocation.state}}</span>
                          <span *ngIf="usage.vehicleLocationDetail.facilityLocation.zipCode">,
                            {{usage.vehicleLocationDetail.facilityLocation.zipCode}}</span>
                        </div>
                      </div>
                      <div class="col-md-3 col-sm-6 col-12 mt-1">
                        <div class="font14-700">Home Location</div>
                        <div class="font13-400 mt-1"
                          *ngIf="usage.homeLocation && usage.homeLocation.address; else noLocation">
                          <span
                            *ngIf="usage.homeLocation.address.street">{{usage.homeLocation.address.street}}</span><br>
                          <span *ngIf="usage.homeLocation.address.city">{{usage.homeLocation.address.city}}</span>
                          <span *ngIf="usage.homeLocation.address.state">, {{usage.homeLocation.address.state}}</span>
                          <span *ngIf="usage.homeLocation.address.zipCode">,
                            {{usage.homeLocation.address.zipCode}}</span>
                        </div>
                      </div> -->
                      <!-- col-md-3  -->
                      <div class="offset-md-3 col-md-6 col-sm-6 col-12 mt-1 pr-0">
                        <div *ngIf="usage.packageName" class="font13-400"><span class="font14-700">Package:
                          </span>{{usage.packageName}}</div><br *ngIf="usage.packageName">
                        <div class="font13-400"><span class="font14-700 mt-1">Service Name:
                          </span>{{usage.serviceName | customText}}
                        </div>
                      </div>
                    </div>
                    <div *ngIf="usage.interimActions && usage.interimActions.length > 0" class="row mt-3">
                      <div class="col-sm-12 col-md table-responsive">
                        <table class="table">
                          <thead class="thead-light cursor-pointer">
                            <tr>
                              <th width="20%" scope="col">Start Date Time</th>
                              <th width="30%" scope="col">End Date Time</th>
                              <th width="20%" scope="col">Request Type</th>
                              <!-- <th scope="col">Operation</th> -->
                              <th width="20%" scope="col">Command</th>
                              <th width="10%" scope="col">Status</th>
                            </tr>
                          </thead>
                          <tbody>
                            <ng-container *ngFor="let action of usage.interimActions;">
                              <tr>
                                <td width="20%">{{action.requestTime | date: utilService.countryData.dateFormat + ' ' + utilService.countryData.timeFormat : utilService.countryData.timezone}}</td>
                                <td width="30%">{{action.lastModifiedDate | date: utilService.countryData.dateFormat + ' ' + utilService.countryData.timeFormat : utilService.countryData.timezone}}</td>
                                <td width="20%">{{action.operation | customText}}</td>
                                <!-- <td></td> -->
                                <td width="20%">{{action.command | customText}}</td>
                                <td width="10%">{{action.operationStatus | customText}}</td>
                              </tr>
                            </ng-container>
                            <!-- <tr *ngIf="usage.notificationAction">
                              <td>{{usage.notificationAction.requestTime | date: utilService.countryData.dateFormat + ' ' + utilService.countryData.timeFormat : utilService.countryData.timezone}}</td>
                              <td>{{usage.notificationAction.lastModifiedDate | date: utilService.countryData.dateFormat + ' ' + utilService.countryData.timeFormat : utilService.countryData.timezone}}</td>
                              <td>{{usage.notificationAction.operation | customText}}</td>
                              <td>{{usage.notificationAction.command | customText}}</td>
                              <td>{{usage.notificationAction.operationStatus | customText}}</td>
                            </tr> -->
                            <ng-container *ngIf="usage.notificationActions">
                              <ng-container *ngFor="let action of usage.notificationActions;">
                                <tr>
                                  <td width="20%">{{action.requestTime | date: utilService.countryData.dateFormat + ' ' + utilService.countryData.timeFormat : utilService.countryData.timezone}}</td>
                                  <td width="30%">{{action.lastModifiedDate | date: utilService.countryData.dateFormat + ' ' + utilService.countryData.timeFormat : utilService.countryData.timezone}}</td>
                                  <td width="20%">{{action.operation | customText}}</td>
                                  <td width="20%">{{action.statusMessage | udrNotification}}</td>
                                  <td width="10%">{{action.operationStatus | customText}}</td>
                                </tr>
                              </ng-container>
                            </ng-container>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
            </ng-container>
          </ng-container>
        </tbody>
      </table>
    </div>
  </ng-container>

  <ng-template #noLocation>
    <div class="font13-400 mt-1">-</div>
  </ng-template>

  <div
    *ngIf="(accountOnboardingData == null || accountOnboardingData.length < 1) && (accountServicePackageProvisioningData == null || accountServicePackageProvisioningData.length < 1) && (vehicleOnboardingData == null || vehicleOnboardingData.length < 1) && (vehicleServicePackageProvisioningData == null || vehicleServicePackageProvisioningData.length < 1) && (userOnboardingData == null || userOnboardingData.length < 1) && (usageUiData == null || usageUiData.length < 1 || allEmailNotification(usageUiData))"
    class="col-12 mt-5 text-center">
    <h3 class="text-muted">No data available for the selected period.</h3>
  </div>
</div>